!function(e){var t=function(){var e=0,t=[["min-height","0px"],["height","1%"]],n=/(msie) ([\w.]+)/.exec(navigator.userAgent.toLowerCase())||[],i=n[1]||"",h=n[2]||"0";return"msie"===i&&7>h&&(e=1),{name:t[e][0],autoheightVal:t[e][1]}};e.getSyncedHeight=function(n){var i=0,h=t();return e(n).each(function(){e(this).css(h.name,h.autoheightVal);var t=parseInt(e(this).css("height"),10);t>i&&(i=t)}),i},e.fn.syncHeight=function(n){var i={updateOnResize:!1,height:!1},h=e.extend(i,n),s=this,a=0,c=t().name;return a="number"==typeof h.height?h.height:e.getSyncedHeight(this),e(this).each(function(){e(this).css(c,a+"px")}),h.updateOnResize===!0&&e(window).resize(function(){e(s).syncHeight()}),this},e.fn.unSyncHeight=function(){var n=t().name;e(this).each(function(){e(this).css(n,"")})}}(jQuery);

function replaceUrlParam(e, a, o) {
    var i = new RegExp("(" + a + "=).*?(&|$)"),
        t = e;
    return e.search(i) >= 0 ? e.replace(i, "$1" + o + "$2") : t + (t.indexOf("?") > 0 ? "&" : "?") + a + "=" + o;
}
function onYouTubeIframeAPIReady() {
    velatheme.SlideshowVideo.loadVideos();
}
"undefined" == typeof Shopify && (Shopify = {}),
    Shopify.formatMoney ||
        (Shopify.formatMoney = function (e, a) {
            var o = "",
                i = /\{\{\s*(\w+)\s*\}\}/,
                t = a || this.money_format;
            function n(e, a) {
                return void 0 === e ? a : e;
            }
            function r(e, a, o, i) {
                if (((a = n(a, 2)), (o = n(o, ",")), (i = n(i, ".")), isNaN(e) || null == e)) return 0;
                var t = (e = (e / 100).toFixed(a)).split(".");
                return t[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (t[1] ? i + t[1] : "");
            }
            switch (("string" == typeof e && (e = e.replace(".", "")), t.match(i)[1])) {
                case "amount":
                    o = r(e, 2);
                    break;
                case "amount_no_decimals":
                    o = r(e, 0);
                    break;
                case "amount_with_comma_separator":
                    o = r(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    o = r(e, 0, ".", ",");
            }
            return t.replace(i, o);
        }),
    (Shopify.optionsMap = {}),
    (Shopify.updateOptionsInSelector = function (e) {
        switch (e) {
            case 0:
                var a = "root",
                    o = jQuery(".single-option-selector:eq(0)");
                break;
            case 1:
                (a = jQuery(".single-option-selector:eq(0)").val()), (o = jQuery(".single-option-selector:eq(1)"));
                break;
            case 2:
                a = jQuery(".single-option-selector:eq(0)").val();
                a += " / " + jQuery(".single-option-selector:eq(1)").val();
                o = jQuery(".single-option-selector:eq(2)");
        }
        var i = o.val();
        o.empty();
        for (var t = Shopify.optionsMap[a], n = 0; n < t.length; n++) {
            var r = t[n],
                s = jQuery("<option></option>").val(r).html(r);
            o.append(s);
        }
        jQuery('.swatch[data-option-index="' + e + '"] .swatch-element').each(function () {
            -1 !== jQuery.inArray($(this).attr("data-value"), t)
                ? $(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled").removeAttr("checked")
                : 1 == window.swatch_show_unvailable
                ? $(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled", "disabled")
                : $(this).addClass("soldout").hide().find(":radio").removeAttr("checked").attr("disabled", "disabled");
        }),
            -1 !== jQuery.inArray(i, t) && o.val(i),
            o.trigger("change");
    }),
    (Shopify.linkOptionSelectors = function (e) {
        for (var a = 0; a < e.variants.length; a++) {
            var o = e.variants[a];
            if (o.available) {
                if (((Shopify.optionsMap.root = Shopify.optionsMap.root || []), Shopify.optionsMap.root.push(o.option1), (Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root)), e.options.length > 1)) {
                    var i = o.option1;
                    (Shopify.optionsMap[i] = Shopify.optionsMap[i] || []), Shopify.optionsMap[i].push(o.option2), (Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i]));
                }
                if (3 === e.options.length) {
                    i = o.option1 + " / " + o.option2;
                    (Shopify.optionsMap[i] = Shopify.optionsMap[i] || []), Shopify.optionsMap[i].push(o.option3), (Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i]));
                }
            }
        }
        Shopify.updateOptionsInSelector(0),
            e.options.length > 1 && Shopify.updateOptionsInSelector(1),
            3 === e.options.length && Shopify.updateOptionsInSelector(2),
            jQuery(".single-option-selector:eq(0)").change(function () {
                return Shopify.updateOptionsInSelector(1), 3 === e.options.length && Shopify.updateOptionsInSelector(2), !0;
            }),
            jQuery(".single-option-selector:eq(1)").change(function () {
                return 3 === e.options.length && Shopify.updateOptionsInSelector(2), !0;
            });
    }),
    (window.vela = window.vela || {}),
    (vela.cacheSelectors = function () {
        vela.cache = { $html: $("html"), $body: $("body"), $velaProductImage: $("#ProductPhotoImg"), $velaLoading: $("#loading") };
    }),
    (vela.init = function () {
        FastClick.attach(document.body),
            vela.cacheSelectors(),
            vela.preLoading(),
            vela.startTheme(),
            vela.drawersInit(),
            vela.swatchProduct(),
            vela.productThumbImage(),
            vela.ajaxSearch(),
            vela.ajaxFilter(),
            vela.accordion(),
            vela.responsiveVideos(),
            vela.floatHeader(),
            vela.menuMobile(),
            vela.productCountdown(),
            vela.owlOneCarousel(),
            vela.quickview(),
            vela.lookbook(),
            vela.goToTop(),
            vela.instagram(),
            vela.productLoadMore(),
            vela.collectionPage(),
            vela.velaAccountPage(),
            "modal" == window.ajaxcart_type && ajaxCart.load();
    }),
    (vela.getHash = function () {
        return window.location.hash;
    }),
    (vela.productPage = function (e) {
        var a = e.money_format,
            o = e.variant,
            i = e.selector,
            t = $("#AddToCart"),
            n = $("#ProductPrice"),
            r = $("#ComparePrice"),
            s = $(".qtySelector, .qtySelector + .velaQty"),
            l = $("#AddToCartText");
        if (o) {
            if (
                (o.available ? (t.removeClass("disabled").prop("disabled", !1), l.html("Add to Cart"), s.show()) : (t.addClass("disabled").prop("disabled", !0), l.html("Sold Out"), s.hide()),
                n.html(Shopify.formatMoney(o.price, a)),
                o.compare_at_price > o.price ? r.html(Shopify.formatMoney(o.compare_at_price, a)).show() : r.hide(),
                window.swatch_enable)
            )
                for (var c = $("#" + i.domIdPrefix).closest("form"), d = 0, u = o.options.length; d < u; d++) {
                    var p = c.find('.swatch[data-option-index="' + d + '"] :radio[value="' + o.options[d] + '"]');
                    p.size() && (p.get(0).checked = !0);
                }
            $(".productSKU").html("<label>SKU</label>" + o.sku),
                o.available
                    ? ($(".productAvailability").removeClass("outstock"), $(".productAvailability").addClass("instock"), $(".productAvailability").html("<label>Availability</label>In stock"))
                    : ($(".productAvailability").removeClass("instock"), $(".productAvailability").addClass("outstock"), $(".productAvailability").html("<label>Availability</label>Out of stock")),
                window.currencies && Currency.convertAll(window.currency, Currency.cookie.read());
        } else {
          t.addClass("disabled").prop("disabled", !0), l.html("Out of stock"), s.hide();
        }
        if (o && o.featured_image) {
            var h = $(".proFeaturedImage img"),
                v = o.featured_image,
                f = h[0];
            Shopify.Image.switchImage(v, f, function (e, a, o) {
                $("#productThumbs img").each(function () {
                    $(this).parent();
                    if ($(this).parent().data("imageid") == a.id) return $(this).parent().trigger("click"), !1;
                });
            });
        }
    }),
    (vela.preLoading = function () {
        var e,
            a = 0,
            o = $("#velaPreLoading"),
            i = $("#velaPreLoading > span"),
            t = new Array();
        function n() {
            a++;
            var e = Math.round((a / t.length) * 100);
            $(i)
                .stop()
                .animate({ width: e + "%" }, 500, "linear"),
                a >= t.length &&
                    ((a = t.length),
                    $(i)
                        .stop()
                        .animate({ width: "100%" }, 500, "linear", function () {
                            $(o).fadeOut(200, function () {
                                $(o).remove();
                            });
                        }));
        }
        o.css({ position: "fixed", top: 0, left: 0, zIndex: 99999, width: "100%", height: "100%", backgroundColor: "rgba(255, 255, 255, 1)" }),
            $("body").removeClass("bodyPreLoading"),
            (e = $("body")),
            $(e)
                .find("*:not(script)")
                .each(function () {
                    var e = "";
                    if (-1 == $(this).css("background-image").indexOf("none") && -1 == $(this).css("background-image").indexOf("-gradient")) {
                        if (-1 != (e = $(this).css("background-image")).indexOf("url")) {
                            var a = e.match(/url\((.*?)\)/);
                            e = a[1].replace(/\"/g, "");
                        }
                    } else "img" == $(this).get(0).nodeName.toLowerCase() && void 0 !== $(this).attr("src") && (e = $(this).attr("src"));
                    e.length > 0 && t.push(e);
                }),
            (function () {
                for (var e = 0; e < t.length; e++)
                    (a = t[e]),
                        (o = void 0),
                        (o = new Image()),
                        $(o)
                            .load(function () {
                                n();
                            })
                            .error(function () {
                                n();
                            })
                            .attr("src", a);
                var a, o;
            })();
    }),
    (vela.startTheme = function () {
        $(".swatch :radio").change(function () {
            var e = $(this).closest(".swatch").attr("data-option-index"),
                a = $(this).val();
            $(this).closest("form").find(".single-option-selector").eq(e).val(a).trigger("change");
        }),
            $(".headerCartModal .overlayCart, .headerCartModal .closeCartModal").on("click", function () {
                $(".headerCartModal").removeClass("active");
            }),
            $("body").on("click", ".velaCartModal", function () {
                $(this).parent().toggleClass("active");
            }),
            $("body").click(function (e) {
                0 === $(e.target).parents(".velaCartTop").length && $(".velaCartTop").removeClass("active");
            }),
            $('[data-toggle="tooltip"]').tooltip(),
            $(".googleOverPlay").on("click", function () {
                $(this).fadeOut();
            }),
            $(".velaGoogleMap").on("mouseleave", function () {
                $(this).find(".googleOverPlay").fadeIn();
            });
    }),
    (vela.drawersInit = function () {
        vela.RightDrawer = new vela.Drawers("cartDrawer", "Right", !0, { onDrawerOpen: ajaxCart.load });
    }),
    (vela.swatchProduct = function () {
        $("body").on("mouseover", ".velaSwatchProduct > li", function () {
            var e = $(this).find(".hidden a").attr("href");
            "#" != e && $(this).parents(".velaProBlock").find(".proFeaturedImage > img").attr({ src: e }).css({ position: "relative", "z-index": "2" });
            return !1;
        }),
            $("body").on("mouseout", ".velaProBlock", function () {
                $(this).find(".proFeaturedImage > img").removeAttr("style");
            });
    }),
    (vela.productThumbImage = function () {
        $("#productThumbs").length > 0 && $("#productThumbs .owl-carousel").owlCarousel({ items: 4, dots: !1, nav: !0 });
    }),
    (vela.ajaxSearch = function () {
        var e = null;
        $('form[action="/search"]').each(function () {
            var a = $(this).find('input[name="q"]'),
                o = $(this).find('input[name="type"]');
            a.position().top, a.innerHeight();
            $('<ul class="velaAjaxSearch"></ul>').appendTo($(this)).hide(),
                "product" == o.val() &&
                    a.attr("autocomplete", "off").bind("keyup change", function () {
                        var a = $(this).val(),
                            o = $(this).closest("form"),
                            i = "/search?type=product&q=" + a,
                            t = o.find(".velaAjaxSearch");
                        a.length > 1 &&
                            a != $(this).attr("data-old-term") &&
                            ($(this).attr("data-old-term", a),
                            null != e && e.abort(),
                            (e = $.getJSON(i + "&view=json", function (e) {
                                t.empty(),
                                    0 == e.results_count
                                        ? t.hide()
                                        : ($.each(e.results, function (e, a) {
                                              if (a.thumbnail.includes("//cdn.shopify.com/shopifycloud/shopify/assets/no-image"));
                                              else {
                                                  var o = $("<a></a>").attr("href", a.url);
                                                  o.append('<span class="searchProductImage"><img src="' + a.thumbnail + '" /></span>'),
                                                      o.append('<span class="searchProductTitle">' + a.title + "</span>"),
                                                      o.wrap("<li></li>"),
                                                      t.append(o.parent());
                                              }
                                          }),
                                          e.results_count > 10 && t.append('<li><a class="searchViewAll" href="' + i + '">See all results (' + e.results_count + ")</a></li>"),
                                          t.fadeIn(200));
                            })));
                    });
        });
        $("body").bind("click", function () {
            $(".velaAjaxSearch").hide();
        }),
            $(".searchBoxTop").hover(function () {
                $(".velaSearchbox .velaSearch").focus();
            }),
            vela.cache.$body.on("click", ".velaSearchIcon", function () {
                $(".searchBoxTop .velaFormSearchInput").focus();
                $(".searchBoxTop").toggleClass("active"), $(".searchClose").toggleClass("active"), $(".searchOverLayer").toggleClass("active");
            }),
            vela.cache.$body.on("click", ".searchClose, .searchOverLayer", function () {
                $(this).hasClass("active") && ($(".searchBoxTop").removeClass("active"), $(".searchClose").removeClass("active"), $(".searchOverLayer").removeClass("active"));
            });
    }),
    (vela.ajaxFilter = function () {
        var e = $(".filterTagFullwidthButton"),
            a = $(".filterTagFullwidthContent");
        vela.cache.$body.on("click", ".filterTagFullwidthButton", function () {
            a.hasClass("active")
                ? (e.removeClass("active"),
                  a.removeClass("active"),
                  $(".filterTagFullwidthOverlay").each(function () {
                      $(this).remove();
                  }))
                : ($('<div class="filterTagFullwidthOverlay"></div>').css("display", "none").insertAfter(a), $(".filterTagFullwidthOverlay").fadeIn(300), e.addClass("active"), a.addClass("active"));
        }),
            vela.cache.$body.on("click", ".filterTagFullwidthOverlay, .filterTagFullwidthClose", function () {
                $(".filterTagFullwidthOverlay").each(function () {
                    $(this).remove();
                }),
                    e.removeClass("active"),
                    a.removeClass("active");
            });
        var o = !1;
        $(".template-collection") &&
            History.Adapter.bind(window, "statechange", function () {
                History.getState();
                if (!o) {
                    ajaxFilterParams();
                    var e = ajaxFilterCreateUrl();
                    ajaxFilterGetContent(e), reActivateSidebar();
                }
                vela.isSidebarAjaxClick = !1;
            }),
            (ajaxFilterParams = function () {
                if (((Shopify.queryParams = {}), location.search.length))
                    for (var e, a = 0, o = location.search.substr(1).split("&"); a < o.length; a++) (e = o[a].split("=")).length > 1 && (Shopify.queryParams[decodeURIComponent(e[0])] = decodeURIComponent(e[1]));
            }),
            (ajaxFilterCreateUrl = function (e) {
                var a = $.param(Shopify.queryParams).replace(/%2B/g, "+");
                return e ? ("" != a ? e + "?" + a : e) : location.pathname + "?" + a;
            }),
            (ajaxFilterClick = function (e) {
                delete Shopify.queryParams.page;
                var a = ajaxFilterCreateUrl(e);
                (o = !0), History.pushState({ param: Shopify.queryParams }, a, a), ajaxFilterGetContent(a);
            }),
            (ajaxFilterSortby = function () {
                if (Shopify.queryParams.sort_by) {
                    var e = Shopify.queryParams.sort_by;
                    $("#SortBy").val(e);
                }
                vela.cache.$body.on("change", "#SortBy", function (e) {
                    (Shopify.queryParams.sort_by = $(this).val()), ajaxFilterClick();
                  location.reload();
                });
            }),
            (ajaxFilterView = function () {
                vela.cache.$body.on("click", ".changeView", function (e) {
                    e.preventDefault(), $(this).hasClass("changeViewActive") || ((Shopify.queryParams.view = $(this).data("view")), $(".changeView").removeClass("changeViewActive"), $(this).addClass("changeViewActive"), ajaxFilterClick());
                });
            }),
            (ajaxFilterTags = function () {
                vela.cache.$body.on("click", ".ajaxFilter li > a", function (e) {
                    e.preventDefault();
                    var a = [];
                    if ((Shopify.queryParams.constraint && (a = Shopify.queryParams.constraint.split("+")), !window.sidebar_multichoise && !$(this).parent().hasClass("active"))) {
                        var o = $(this).parents(".listFilter").find("li.active");
                        if (o.length > 0) {
                            var i = o.data("filter");
                            if (i) (t = a.indexOf(i)) >= 0 && a.splice(t, 1);
                        }
                    }
                    var t,
                        n = $(this).parent().data("filter");
                    n && ((t = a.indexOf(n)) >= 0 ? a.splice(t, 1) : a.push(n));
                    a.length ? (Shopify.queryParams.constraint = a.join("+")) : delete Shopify.queryParams.constraint, ajaxFilterClick();
                });
            }),
            (ajaxFilterPaging = function () {
                vela.cache.$body.on("click", "#collPagination .pagination a", function (e) {
                    e.preventDefault();
                    var a = $(this)
                        .attr("href")
                        .match(/page=\d+/g);
                    if (a && ((Shopify.queryParams.page = parseInt(a[0].match(/\d+/g))), Shopify.queryParams.page)) {
                        var i = ajaxFilterCreateUrl();
                        (o = !0), History.pushState({ param: Shopify.queryParams }, i, i), ajaxFilterGetContent(i), $("body,html").animate({ scrollTop: 300 }, 600);
                    }
                });
            }),
            (ajaxFilterReview = function () {
                if (window.review && $(".shopify-product-reviews-badge").length > 0) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
            }),
            (ajaxFilterClear = function () {
                $(".ajaxFilter").each(function () {
                    var e = $(this);
                    e.find(".listFilter > li.active").length > 0 &&
                        e
                            .find(".velaClear")
                            .show()
                            .click(function (a) {
                                var o = [];
                                Shopify.queryParams.constraint && (o = Shopify.queryParams.constraint.split("+")),
                                    e.find(".listFilter > li.active").each(function () {
                                        var e = $(this).data("filter");
                                        if (e) {
                                            var a = o.indexOf(e);
                                            a >= 0 && o.splice(a, 1);
                                        }
                                    }),
                                    o.length ? (Shopify.queryParams.constraint = o.join("+")) : delete Shopify.queryParams.constraint,
                                    ajaxFilterClick();
                            });
                });
            }),
            (ajaxFilterClearAll = function () {
                vela.cache.$body.on("click", "a.velaClearAll", function (e) {
                    delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, ajaxFilterClick();
                });
            }),
            (ajaxFilterAddToCart = function () {
                "page" != window.ajaxcart_type &&
                    ajaxCart.init({ formSelector: ".formAddToCart", cartContainer: "#cartContainer", addToCartSelector: ".btnAddToCart", cartCountSelector: "#CartCount", cartCostSelector: "#CartCost", moneyFormat: null });
            }),
            (ajaxAccordionMobile = function () {
                $(".velaSidebar").hasClass("accordion") &&
                    $("#sidebarAjaxFilter .titleSidebar").on("click", function (e) {
                        $(this).toggleClass("active").parent().find(".velaContent").stop().slideToggle("medium"), e.preventDefault();
                    });
            }),
            (ajaxFilterData = function (e) {
                var a = $("#proListCollection .proList"),
                    o = $(e).find("#proListCollection .proList");
                a.replaceWith(o), $("#collPagination").length > 0 ? $("#collPagination").replaceWith($(e).find("#collPagination")) : $("#shopify-section-vela-template-collection").append($(e).find("#collPagination"));
                var i = $("#sidebarAjaxFilter"),
                    t = $(e).find("#sidebarAjaxFilter");
                i.replaceWith(t);
            }),
            (ajaxFilterGetContent = function (e) {
                $.ajax({
                    type: "get",
                    url: e,
                    beforeSend: function () {
                        vela.cache.$velaLoading.show();
                    },
                    success: function (e) {
                        var a = $(e).filter("title").text();
                        (document.title = a), ajaxFilterData(e), ajaxFilterSortby(), ajaxFilterReview(), ajaxFilterClear(), ajaxFilterAddToCart(), ajaxAccordionMobile(), vela.cache.$velaLoading.hide();
                        var content = $(e);
                        var count = $(".collProductCount", content);
                        $(".collProductCount").text( count.text() );

                    },
                    error: function (e, a) {
                        vela.cache.$velaLoading.hide();
                    },
                });
            }),
            ajaxFilterParams(),
            ajaxFilterSortby(),
            ajaxFilterView(),
            ajaxFilterTags(),
            ajaxFilterPaging(),
            ajaxFilterClear(),
            ajaxFilterClearAll();
    }),
    (vela.accordion = function () {
        function e() {
            $(window).width() <= 767
                ? $(".velaSidebar").hasClass("accordion") ||
                  ($(".velaSidebar .titleSidebar").on("click", function (e) {
                      $(this).toggleClass("active").parent().find(".velaContent").stop().slideToggle("medium"), e.preventDefault();
                  }),
                  $(".velaSidebar").addClass("accordion").find(".velaContent").slideUp("fast"))
                : ($(".velaSidebar .titleSidebar").removeClass("active").off().parent().find(".velaContent").removeAttr("style").slideDown("fast"), $(".velaSidebar").removeClass("accordion"));
        }
        function a() {

            /*
            $(window).width() <= 767
                ? $(".velaFooter").hasClass("accordion") ||
                  ($(".velaFooter .velaFooterTitle").on("click", function (e) {
                      $(this).toggleClass("active").parent().find(".velaContent").stop().slideToggle("medium"), e.preventDefault();
                  }),
                  $(".velaFooter").addClass("accordion").find(".velaContent").slideUp("fast"))
                : ($(".velaFooter .velaFooterTitle").removeClass("active").off().parent().find(".velaContent").removeAttr("style").slideDown("fast"), $(".velaFooter").removeClass("accordion"));
            */
        }
        e(), a(), $(window).resize(e), $(window).resize(a);
    }),
    (vela.responsiveVideos = function () {
        var e = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'),
            a = e.add("iframe#admin_bar_iframe");
        e.each(function () {
            $(this).wrap('<div class="videoContainer"></div>');
        }),
            a.each(function () {
                this.src = this.src;
            });
    }),
    (vela.floatHeader = function () {
        function e(e) {
            var a = $("#velaHeader");
            if (e) {
                a.addClass("headerFixed"), $(".mainContent").css("padding-top", a.height()), $('.searchBoxTop').css('top', a.height());;
                
                var o = a.height() + 400,
                    i = ($(window).scrollTop(), 0);
                $(window).scroll(function () {
                    st = $(this).scrollTop();
                    var e = $(window).scrollTop();

                    if( e >= o ) {
                      a.addClass("headerFixedDisplay");
                      a.addClass("sticky");
                      a.removeClass("headerFixedHidden");
                      $("#announcement-bar").addClass( 'sticky-announcement-bar');
                    } else {
                      a.removeClass("headerFixedDisplay");
                      a.removeClass("sticky");
                      a.removeClass("headerFixedHidden");
                      $("#announcement-bar").removeClass( 'sticky-announcement-bar');
                    }
                    /*
                      st < i
                        ? e >= o
                            ? (a.addClass("headerFixedHidden"), a.addClass("headerFixedDisplay"))
                            : a.addClass("headerFixedDisplay")
                        : e >= o
                        ? (a.addClass("headerFixedDisplay"), a.addClass("headerFixedHidden"))
                        : a.addClass("headerFixedHidden"),
                        (i = st);
                    */
                });
            } else {
                a.removeClass("headerFixed"), a.removeClass("headerFixedScroll"), $(".mainContent").css("padding-top", ""), $('.searchBoxTop').css('top', "");;
                $("#announcement-bar").removeClass("sticky-announcement-bar");
            }
        }
        function a() {
            window.float_header && ($(window).width() >= 992 ? e(!0) : $(window).width() <= 991 && e(!1));
        }
        a(), $(window).resize(a);
    }),
    (vela.menuMobile = function () {
        vela.cache.$body.on("click", "#btnMenuMobile", function (e) {
            e.preventDefault(), $("body").toggleClass("menuMobileActive");
        }),
            vela.cache.$body.on("click", ".btnMenuClose, .menuMobileOverlay", function (e) {
                e.preventDefault(), $("body").removeClass("menuMobileActive");
            });
    }),
    (vela.productCountdown = function () {
        $("[data-countdown]").each(function () {
            var e = $(this),
                a = $(this).data("countdown");
            e.countdown(a, function (a) {
                e.html(a.strftime(window.countdown_format));
            });
        });
    }),
    (vela.owlOneCarousel = function () {
        $(".owlCarouselPlay .owl-carousel").each(function () {
            var e = $(this),
                a = e.data("nav"),
                o = e.data("navText"),
                i = e.data("dots"),
                t = e.data("autoplay"),
                n = e.data("autoplaytimeout"),
                r = e.data("loop"),
                s = e.data("margin"),
                l = e.data("center"),
                c = e.data("columnone"),
                d = e.data("columntwo"),
                u = e.data("columnthree"),
                p = e.data("columnfour"),
                h = { margin: s, nav: a, responsive: { 0: { items: 1 }, 360: { items: e.data("columnfive") }, 480: { items: p }, 768: { items: u }, 992: { items: d }, 1200: { items: c } } };
            void 0 === i || null == i || i.length <= 0 || 1 != i ? (h.dots = !1) : (h.dots = !0),
                void 0 === o || null == o || o.length <= 0 || (h.navText = o),
                void 0 === r || null == r || r.length <= 0 || (h.loop = r),
                void 0 === l || null == l || r.center <= 0 || (h.center = l),
                t && ((h.autoplay = t), (h.autoplayTimeout = n), (h.autoplayHoverPause = !0)),
                e.owlCarousel(h);
        });
    }),
    (vela.lookbook = function () {
        vela.cache.$body.on("click", ".lookbItemButton", function () {
            var e = $(this).parents(".velaBoxLookbook"),
                a = e.find(".lookbItem"),
                o = e.find(".lookbItemContent");
            e.hasClass("active")
                ? (e.removeClass("active"), $(".velaBoxLookbookOverlay").remove(), $(".velaBoxLookbookClose").remove())
                : (e.addClass("active"), a.prepend('<div class="velaBoxLookbookOverlay"></div>'), o.prepend('<div class="velaBoxLookbookClose"></div>'), o.fadeIn(500));
        }),
            vela.cache.$body.on("click", ".velaBoxLookbookOverlay, .velaBoxLookbookClose", function () {
                $(".velaBoxLookbook").removeClass("active"), $(".velaBoxLookbookOverlay").remove(), $(".velaBoxLookbookClose").remove(), $(".lookbItemContent").fadeOut(500);
            });
    }),
    (vela.quickview = function () {
        (Shopify.doNotTriggerClickOnThumb = !1),
            (selectCallbackQuickView = function (e, a) {
                var o = jQuery(".jsQuickview .proBoxInfo"),
                    i = o.find(".btnAddToCart"),
                    t = o.find(".proQuantity"),
                    n = o.find(".pricePrimary"),
                    r = o.find(".priceCompare");
                if (e) {
                    if (
                        (o.find(".quickViewSKU").html("<label>SKU</label>" + e.sku),
                        e.available
                            ? (i.removeClass("disabled").removeAttr("disabled"),
                              i.html("Add to Cart"),
                              t.show(),
                              o.find(".proBoxInfo .quickviewAvailability").removeClass("outstock").addClass("instock"),
                              o.find(".proBoxInfo .quickviewAvailability").append("<label>Availability</label>In stock"))
                            : (i.addClass("disabled").attr("disabled", "disabled"),
                              i.html("Sold Out"),
                              t.hide(),
                              o.find(".proBoxInfo .quickviewAvailability").removeClass("instock").addClass("outstock"),
                              o.find(".proBoxInfo .quickviewAvailability").append("<label>Availability</label>Out of stock")),
                        n.html(Shopify.formatMoney(e.price, window.money)),
                        e.compare_at_price > e.price ? r.html(Shopify.formatMoney(e.compare_at_price, window.money)).show() : r.hide(),
                        window.swatch_enable)
                    ) {
                        o.find(".selector-wrapper").addClass("hiddenVariant");
                        for (var s = jQuery("#" + a.domIdPrefix).closest("form"), l = 0, c = e.options.length; l < c; l++) {
                            var d = s.find('.swatch[data-option-index="' + l + '"] :radio[value="' + e.options[l] + '"]');
                            d.size() && (d.get(0).checked = !0);
                        }
                    }
                    if (e && e.featured_image) {
                        var u = $(".proImageQuickview"),
                            p = e.featured_image,
                            h = u[0];
                        Shopify.Image.switchImage(p, h, function (e, a, o) {
                            $(".proThumbnails img").each(function () {
                                $(this).parent();
                                var a = $(this).parent().data("image");
                                if (e.includes(a)) return $(this).parent().trigger("click"), !1;
                            });
                        });
                    }
                    window.currencies && Currency.convertAll(window.currency, Currency.cookie.read());
                } else i.addClass("disabled").attr("disabled", "disabled"), i.html("Out of stock"), t.hide();
            }),
            (changeImageQuickView = function (e, a) {
                var o = $(e).attr("src");
                (o = o.replace("_compact", "")), $(a).attr("src", o);
            }),
            (velaUpdateOptionsInSelector = function (e) {
                switch (e) {
                    case 0:
                        var a = "root",
                            o = $(".jsQuickview .single-option-selector:eq(0)");
                        break;
                    case 1:
                        (a = $(".jsQuickview .single-option-selector:eq(0)").val()), (o = $(".jsQuickview .single-option-selector:eq(1)"));
                        break;
                    case 2:
                        a = $(".jsQuickview .single-option-selector:eq(0)").val();
                        a += " / " + $(".jsQuickview .single-option-selector:eq(1)").val();
                        o = $(".jsQuickview .single-option-selector:eq(2)");
                }
                var i = o.val();
                o.empty();
                var t = Shopify.optionsMapQuickview[a];
                if (void 0 !== t)
                    for (var n = 0; n < t.length; n++) {
                        var r = t[n],
                            s = $("<option></option>").val(r).html(r);
                        o.append(s);
                    }
                $('.jsQuickview .swatch[data-option-index="' + e + '"] .swatch-element').each(function () {
                    -1 !== $.inArray($(this).attr("data-value"), t)
                        ? $(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled")
                        : 1 == window.swatch_show_unvailable
                        ? $(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled", "disabled")
                        : $(this).addClass("soldout").hide().find(":radio").removeAttr("checked").attr("disabled", "disabled");
                }),
                    -1 !== $.inArray(i, t) && o.val(i),
                    o.trigger("change");
            }),
            (velaLinkOptionSelectors = function (e) {
                for (var a = 0; a < e.variants.length; a++) {
                    var o = e.variants[a];
                    if (o.available) {
                        if (
                            ((Shopify.optionsMapQuickview.root = Shopify.optionsMapQuickview.root || []),
                            Shopify.optionsMapQuickview.root.push(o.option1),
                            (Shopify.optionsMapQuickview.root = Shopify.uniq(Shopify.optionsMapQuickview.root)),
                            e.options.length > 1)
                        ) {
                            var i = o.option1;
                            (Shopify.optionsMapQuickview[i] = Shopify.optionsMapQuickview[i] || []), Shopify.optionsMapQuickview[i].push(o.option2), (Shopify.optionsMapQuickview[i] = Shopify.uniq(Shopify.optionsMapQuickview[i]));
                        }
                        if (3 === e.options.length) {
                            i = o.option1 + " / " + o.option2;
                            (Shopify.optionsMapQuickview[i] = Shopify.optionsMapQuickview[i] || []), Shopify.optionsMapQuickview[i].push(o.option3), (Shopify.optionsMapQuickview[i] = Shopify.uniq(Shopify.optionsMapQuickview[i]));
                        }
                    }
                }
                velaUpdateOptionsInSelector(0),
                    e.options.length > 1 && velaUpdateOptionsInSelector(1),
                    3 === e.options.length && velaUpdateOptionsInSelector(2),
                    $("#productSelectQuickview-option-0").change(function () {
                        return velaUpdateOptionsInSelector(1), 3 === e.options.length && velaUpdateOptionsInSelector(2), !0;
                    }),
                    $("#productSelectQuickview-option-1").change(function () {
                        return 3 === e.options.length && velaUpdateOptionsInSelector(2), !0;
                    });
            }),
            (loadQuickViewSlider = function (e, a) {
                var o = $(".loadingImage");
                Shopify.resizeImage(e.featured_image, "grande");
                if ((o.hide(), e.images.length > 0)) {
                    var t = a.find(".proThumbnailsQuickview .owl-carousel");
                    for (i in e.images) {
                        var n = Shopify.resizeImage(e.images[i], "grande"),
                            r = Shopify.resizeImage(e.images[i], "compact"),
                            s = '<div class="thumbItem"><a href="javascript:void(0)" data-imageid="' + e.id + '" data-image="' + e.images[i] + '" data-zoom-image="' + n + '" ><img src="' + r + '" alt="Produc Image" /></a></div>';
                        t.append(s);
                    }
                    t.find("a").click(function () {
                        var e = a.find(".proImageQuickview");
                        e.attr("src") != $(this).attr("data-image") &&
                            (e.attr("src", $(this).attr("data-image")),
                            o.show(),
                            e.load(function (e) {
                                $(this).unbind("load"), o.hide();
                            }));
                    }),
                        t.owlCarousel({ items: 4, nav: !0, dots: !1 }).css("visibility", "visible");
                } else a.find(".jsQuickview .proThumbnailsQuickview").remove();
            }),
            (convertToSlug = function (e) {
                return e
                    .toLowerCase()
                    .replace(/[^a-z0-9 -]/g, "")
                    .replace(/\s+/g, "-")
                    .replace(/-+/g, "-");
            }),
            (addCheckedSwatch = function () {
                vela.cache.$body.on("click", ".swatch .color label", function () {
                    $(".swatch .color").each(function () {
                        $(this).find("label").removeClass("checkedBox");
                    }),
                        $(this).addClass("checkedBox");
                });
            }),
            (quickViewVariants = function (e, a) {
                if (e.variants.length > 1) {
                    for (var o = 0; o < e.variants.length; o++) {
                        var i = '<option value="' + (d = e.variants[o]).id + '">' + d.title + "</option>";
                        a.find("form.formQuickview .proVariantsQuickview > select").append(i);
                    }
                    if (
                        (new Shopify.OptionSelectors("productSelectQuickview", { product: e, onVariantSelected: selectCallbackQuickView }),
                        1 == e.options.length && $("form.formQuickview .selector-wrapper:eq(0)").prepend("<label>" + e.options[0].name + "</label>"),
                        a.find("form.formQuickview .selector-wrapper label").each(function (a, o) {
                            $(this).html(e.options[a].name);
                        }),
                        window.swatch_enable)
                    ) {
                        var t = window.file_url.substring(0, window.file_url.lastIndexOf("?")),
                            n = window.asset_url.substring(0, window.asset_url.lastIndexOf("?")),
                            r = "";
                        for (o = 0; o < e.options.length; o++) {
                            (r += '<div class="swatch clearfix" data-option-index="' + o + '">'), (r += '<div class="header">' + e.options[o].name + "</div>");
                            var s = !1;
                            /Color|Colour/i.test(e.options[o].name) && (s = !0);
                            for (var l = new Array(), c = 0; c < e.variants.length; c++) {
                                var d,
                                    u = (d = e.variants[c]).options[o],
                                    p = this.convertToSlug(u),
                                    h = "quickview-swatch-" + o + "-" + p;
                                l.indexOf(u) < 0 &&
                                    ((r += '<div data-value="' + u + '" class="swatch-element ' + (s ? "color " : "") + p + (d.available ? " available " : " soldout ") + '">'),
                                    s && (r += '<div class="tooltip">' + u + "</div>"),
                                    (r += '<input id="' + h + '" type="radio" name="option-' + o + '" value="' + u + '" ' + (0 == c ? " checked " : "") + (d.available ? "" : " disabled") + " />"),
                                    (r += s
                                        ? '<label class="' + p + '" for="' + h + '" style="background-color: ' + p + "; background-image: url(" + t + p + '.png)"><img class="crossed-out" src="' + n + 'soldout.png" /><i></i></label>'
                                        : '<label class="' + p + '" for="' + h + '">' + u + '<img class="crossed-out" src="' + n + 'soldout.png" /></label>'),
                                    (r += "</div>"),
                                    d.available &&
                                        $('.jsQuickview .swatch[data-option-index="' + o + '"] .' + p)
                                            .removeClass("soldout")
                                            .addClass("available")
                                            .find(":radio")
                                            .removeAttr("disabled"),
                                    l.push(u));
                            }
                            r += "</div>";
                        }
                        a.find("form.formQuickview .proVariantsQuickview > select").after(r),
                            a.find(".swatch :radio").change(function () {
                                var e = $(this).closest(".swatch").attr("data-option-index"),
                                    a = $(this).val();
                                $(this).closest("form").find(".single-option-selector").eq(e).val(a).trigger("change");
                            }),
                            addCheckedSwatch();
                    }
                    e.available && ((Shopify.optionsMapQuickview = {}), window.swatch_show_unvailable ? window.swatch_enable && velaLinkOptionSelectors(e) : velaLinkOptionSelectors(e));
                } else {
                    a.find("form.formQuickview .proVariantsQuickview > select").remove();
                    var v = '<input type="hidden" name="id" value="' + e.variants[0].id + '">';
                    a.find("form.formQuickview").append(v);
                }
            }),
            (validateQty = function (e) {
                return (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1), e;
            }),
            (qvAddToCart = function () {
                "page" != window.ajaxcart_type &&
                    ajaxCart.init({ formSelector: ".formQuickview", cartContainer: "#cartContainer", addToCartSelector: ".btnAddToCart", cartCountSelector: "#CartCount", cartCostSelector: "#CartCost", moneyFormat: null });
            }),
            $(document).on("click", ".proThumbnailsQuickview li", function () {
                changeImageQuickView($(this).find("img:first-child"), ".proImageQuickview");
            }),
            $(document).on("click", ".quickviewClose, .quickviewOverlay", function (e) {
                $("#velaQuickView").fadeOut(500), $(".jsQuickview").html(""), $(".jsQuickview").fadeOut(500);
            }),
            $(document).on("click", ".btnProductQuickview", function (e) {
                vela.cache.$velaLoading.show();
                var a = $(this).data("handle");
                var clickedBtn = $( this );
                return (
                    Shopify.getProduct(a, function (e) {
                        var a = $("#quickviewModal").html();
                        $(".jsQuickview").html(a);
                        var o = $(".jsQuickview"),
                            i = e.description.replace(/(<([^>]+)>)/gi, ""),
                            t = "",
                            n = e.featured_image;
                        -1 != e.description.indexOf("[SHORTDESCRIPTION]")
                            ? ((t = e.description.split("[SHORTDESCRIPTION]")[0]), o.find(".proDescription").html(t))
                            : ((t = i.split(" ").splice(0, 30).join(" ") + "..."), o.find(".proDescription").text(t)),
                            o.find(".proImageQuickview").attr("src", n),
                            o.find(".proImage").attr("href", e.url),
                            o.find(".pricePrimary").html(Shopify.formatMoney(e.price, window.money)),
                            o.find(".proBoxInfo").attr("id", "product-" + e.id),
                            o.find(".formQuickview").attr("id", "product-actions-" + e.id),
                            o.find(".formQuickview select").attr("id", "productSelectQuickview"),
                            o.find(".proBoxInfo .quickviewName").html("<a href='" + e.url + "'>" + e.title + "</a>"),
                            o.find(".proBoxInfo .quickViewVendor").append("<label>Vendor</label>" + e.vendor),
                            o.find(".proBoxInfo .quickViewType").append(e.type),
                            o.find(".proBoxInfo .quickViewSKU").append("<label>SKU</label>" + e.variants[0].sku),
                            e.available
                                ? (o.find(".proBoxInfo .quickviewAvailability").removeClass("outstock").addClass("instock"), o.find(".proBoxInfo .quickviewAvailability").append("<label>Availability</label>In stock"))
                                : (o.find(".proBoxInfo .quickviewAvailability").removeClass("instock").addClass("outstock"), o.find(".proBoxInfo .quickviewAvailability").append("<label>Availability</label>Out of stock")),
                            e.compare_at_price > e.price ? o.find(".priceCompare").html(Shopify.formatMoney(e.compare_at_price_max, window.money)).show() : o.find(".priceCompare").html(""),
                            e.available ? quickViewVariants(e, o) : (o.find("select, input").hide(), o.find(".btnAddToCart").html("Sold Out").addClass("disabled").attr("disabled", "disabled"), o.find(".proQuantity").hide()),
                            loadQuickViewSlider(e, o),
                            $("#velaQuickView").fadeIn(500);

                            if( $('.disable-product-location').length > 0 ) {
                              $('.jsQuickview .proBoxInfo > .proDescription').remove();
                              $('.formQuickview').hide(0);
                              var description = $('.formQuickview div.proDescription').html();
                              var supplierMessage = clickedBtn.parents('.velaProBlock').find('.disable-product-location').html();
                              $('.formQuickview').after( "<div class='proDescription rte'>" + description + "</div><div class='proDescription rte'>" + supplierMessage + "</div>" );
                            } else {
                              $('.jsQuickview .proBoxInfo > .proDescription').remove();
                              $('.formQuickview').show(0);
                            }
                      
                            $(".jsQuickview").fadeIn(500),
                            vela.cache.$velaLoading.hide(),
                            qvAddToCart(),
                            window.currencies && Currency.convertAll(window.currency, Currency.cookie.read());
                            
                    }),
                    !1
                );
            });
    }),
    (vela.goToTop = function () {
        $(window).scroll(function () {
            $(window).scrollTop() >= 200 ? $("#goToTop").fadeIn() : $("#goToTop").fadeOut();
        }),
            $("#goToTop").click(function () {
                return $("body,html").animate({ scrollTop: 0 }, "normal"), $("#pageContainer").animate({ scrollTop: 0 }, "normal"), !1;
            });
    }),
    (vela.instagram = function () {
        $(".velaInstagram .boxInstagram").each(function () {
            var e = $(this),
                a = $(this).next(".insLoadMore").find(".btnInsLoadMore"),
                o = e.data("id"),
                i = e.data("userid"),
                t = e.data("accesstoken"),
                n = e.data("limit"),
                r = e.data("resolution"),
                s = new Instafeed({
                    get: "user",
                    userId: i,
                    accessToken: t,
                    target: o,
                    limit: n,
                    resolution: r,
                    template: '<a href="{{link}}" title="{{caption}}"><img class="img-responsive" alt="{{caption}}" src="{{image}}" /><span class="likes">{{likes}}</span></a>',
                    before: function () {},
                    after: function () {
                        this.hasNext() || a.addClass("disabled");
                    },
                    success: function () {},
                    error: function () {},
                });
            a.on("click", function () {
                s.next();
            }),
                s.run();
        });
    }),
    (vela.productLoadMore = function () {
        function e() {
            $(".productLoadMore .btnLoadMore").click(function (a) {
                return $(this).hasClass("disableLoadMore")
                    ? (a.stopPropagation(), !1)
                    : ((o = $(".productLoadMore .btnLoadMore")),
                      (i = $(".productLoadMore .btnLoadMore").attr("href")),
                      $.ajax({
                          type: "GET",
                          url: i,
                          beforeSend: function () {
                              vela.cache.$velaLoading.show();
                          },
                          success: function (a) {
                              o.remove(), vela.cache.$velaLoading.hide(), $(a).find(".producsLoadMore").insertBefore($(".proLoadMoreBottom")), e();
                          },
                          dataType: "html",
                      }),
                      a.stopPropagation(),
                      !1);
                var o, i;
            });
        }
        e();
    }),
    (vela.collectionPage = function () {
        $("#velaProList").jscroll({
            nextSelector: "div.moreCollection:last a",
            loadingHtml: '<div class="infiniteLoading"><span class="btnLoadMoreProduct">Loading ...</span></div>',
            contentSelector: "#velaProList > div",
            callback: function () {
                var e = $(".jsvela-currency__item.active").data("value");
                Currency.convertAll(Currency.currentCurrency, e);
            },
        });
    }),
    (vela.velaAccountPage = function () {
        $("body").on("click", ".velaRecoverPassword", function (e) {
            e.preventDefault(), $("#RecoverPasswordForm").removeClass("hidden"), $("#CustomerLoginForm").addClass("hidden");
        }),
            $("body").on("click", ".velaHideRecoverPasswordLink", function (e) {
                e.preventDefault(), $("#RecoverPasswordForm").addClass("hidden"), $("#CustomerLoginForm").removeClass("hidden");
            }),
            "#recover" == vela.getHash() && ($("#RecoverPasswordForm").removeClass("hidden"), $("#CustomerLoginForm").addClass("hidden")),
            $("body").on("click", ".velaShowPassword", function (e) {
                var a = $(this),
                    o = a.prev("input");
                "password" == o.attr("type") ? (o.attr("type", "text"), a.text("Hide")) : (o.attr("type", "password"), a.text("Show"));
            });
    }),
    (vela.productImage = function () {
        if (vela.cache.$velaProductImage.length > 0)
            if ($(window).width() >= 992) {
                var e = vela.cache.$velaProductImage.data("zoom-enable"),
                    a = vela.cache.$velaProductImage.data("zoom-scroll"),
                    o = vela.cache.$velaProductImage.data("zoom-type"),
                    i = vela.cache.$velaProductImage.data("zoom-width"),
                    t = vela.cache.$velaProductImage.data("zoom-height"),
                    n = vela.cache.$velaProductImage.data("zoom-lens"),
                    r = vela.cache.$velaProductImage.data("lens-shape");
                vela.cache.$velaProductImage.data("lens-border");
                vela.cache.$velaProductImage.elevateZoom({
                    zoomEnabled: e,
                    imageCrossfade: e,
                    gallery: "productThumbs",
                    galleryActiveClass: "active",
                    cursor: "pointer",
                    zoomType: o,
                    scrollZoom: a,
                    zoomWindowWidth: i,
                    zoomWindowHeight: t,
                    lensSize: n,
                    lensShape: r,
                    onImageSwapComplete: function () {
                        $(".zoomWrapper div").hide();
                    },
                });
                var s = [],
                    l = vela.cache.$velaProductImage.data("elevateZoom");
                $.each(l.getGalleryList(), function (e, a) {
                    s.push({ src: a.href });
                }),
                    vela.cache.$velaProductImage.bind("click", function (e) {
                        return $.fancybox.open(s), !1;
                    });
            } else if ($(window).width() <= 991) {
                vela.cache.$velaProductImage.elevateZoom({ zoomEnabled: !1, gallery: "productThumbs" });
                (s = []), (l = vela.cache.$velaProductImage.data("elevateZoom"));
                $.each(l.getGalleryList(), function (e, a) {
                    s.push({ src: a.href });
                }),
                    vela.cache.$velaProductImage.unbind("click"),
                    $(".proFeaturedImage").bind("click", function (e) {
                        return $.fancybox.open(s), !1;
                    });
            }
    }),
    (vela.Drawers = (function () {
        var e = function (e, a, o, i) {
            var t = { close: ".jsDrawerClose", open: ".jsDrawerOpen" + a, openClass: "jsDrawerOpen", dirOpenClass: "jsDrawerOpen" + a };
            if (((this.$nodes = { parent: $("body, html"), page: $("#pageContainer"), moved: $(".isMoved") }), (this.config = $.extend(t, i)), (this.position = a), (this.iscart = o), (this.$drawer = $("#" + e)), !this.$drawer.length))
                return !1;
            (this.drawerIsOpen = !1), this.init();
        };
        return (
            (e.prototype.init = function () {
                $(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.find(this.config.close).on("click", $.proxy(this.close, this));
            }),
            (e.prototype.open = function (e) {
                if ("modal" == window.ajaxcart_type && this.iscart) {
                    var a = !1;
                    this.$drawer.modal(),
                        e ? e.preventDefault() : (a = !0),
                        e && e.stopPropagation && (e.stopPropagation(), (this.$activeSource = $(e.currentTarget))),
                        this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && (a || this.config.onDrawerOpen());
                } else {
                    a = !1;
                    if ((e ? e.preventDefault() : (a = !0), e && e.stopPropagation && (e.stopPropagation(), (this.$activeSource = $(e.currentTarget))), this.drawerIsOpen && !a)) return this.close();
                    this.$nodes.moved.addClass("is-transitioning"),
                        this.$drawer.prepareTransition(),
                        this.$nodes.parent.addClass(this.config.openClass + " " + this.config.dirOpenClass),
                        (this.drawerIsOpen = !0),
                        this.trapFocus(this.$drawer, "drawer_focus"),
                        this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && (a || this.config.onDrawerOpen()),
                        this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"),
                        this.$nodes.page.on("touchmove.drawer", function () {
                            return !1;
                        }),
                        this.$nodes.page.on(
                            "click.drawer",
                            $.proxy(function () {
                                return this.close(), !1;
                            }, this)
                        );
                }
            }),
            (e.prototype.close = function () {
                this.drawerIsOpen &&
                    ($(document.activeElement).trigger("blur"),
                    this.$nodes.moved.prepareTransition({ disableExisting: !0 }),
                    this.$drawer.prepareTransition({ disableExisting: !0 }),
                    this.$nodes.parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass),
                    (this.drawerIsOpen = !1),
                    this.removeTrapFocus(this.$drawer, "drawer_focus"),
                    this.$nodes.page.off(".drawer"));
            }),
            (e.prototype.trapFocus = function (e, a) {
                var o = a ? "focusin." + a : "focusin";
                e.attr("tabindex", "-1"),
                    e.focus(),
                    $(document).on(o, function (a) {
                        e[0] === a.target || e.has(a.target).length || e.focus();
                    });
            }),
            (e.prototype.removeTrapFocus = function (e, a) {
                var o = a ? "focusin." + a : "focusin";
                e.removeAttr("tabindex"), $(document).off(o);
            }),
            e
        );
    })()),
    (window.velatheme = window.velatheme || {}),
    (velatheme.Sections = function () {
        (this.constructors = {}), (this.instances = []);
    }),
    (velatheme.Sections.prototype = _.assignIn({}, velatheme.Sections.prototype, {
        _createInstance: function (e, a) {
            var o = $(e),
                i = o.attr("data-section-id"),
                t = o.attr("data-section-type");
            if (((a = a || this.constructors[t]), !_.isUndefined(a))) {
                var n = _.assignIn(new a(e), { id: i, type: t, container: e });
                this.instances.push(n);
            }
        },
        register: function (e, a) {
            (this.constructors[e] = a),
                $("[data-section-type=" + e + "]").each(
                    function (e, o) {
                        this._createInstance(o, a);
                    }.bind(this)
                );
        },
    })),
    (velatheme.Slideshow = (function () {
        this.$slideshow = null;
        var e = "velaSlideshowWrapper",
            a = "slick-current",
            o = "velassVideo",
            i = "velassVideoBackground",
            t = "btnssVideoControlClose",
            n = "btnssPause",
            r = "is-paused";
        function s(a) {
            (this.$slideshow = $(a)),
                (this.$wrapper = this.$slideshow.closest("." + e)),
                (this.$pause = this.$wrapper.find("." + n)),
                (this.settings = {
                    accessibility: !0,
                    arrows: this.$slideshow.data("navigation"),
                    dots: this.$slideshow.data("pagination"),
                    fade: !0,
                    pauseOnHover: !0,
                    draggable: !0,
                    touchThreshold: 20,
                    autoplay: this.$slideshow.data("autoplay"),
                    autoplaySpeed: this.$slideshow.data("speed"),
                }),
                this.$slideshow.on("beforeChange", c.bind(this)),
                this.$slideshow.on("init", l.bind(this)),
                this.$slideshow.slick(this.settings),
                this.$pause.on("click", this.togglePause.bind(this));
        }
        function l(e, a) {
            var o = a.$slider,
                i = a.$list,
                n = this.$wrapper,
                r = this.settings.autoplay;
            o.removeClass("velaSliderLoading"),
                i.removeAttr("aria-live"),
                n.on("focusin", function (e) {
                    n.has(e.target).length && (i.attr("aria-live", "polite"), r && o.slick("slickPause"));
                }),
                n.on("focusout", function (e) {
                    if (n.has(e.target).length && (i.removeAttr("aria-live"), r)) {
                        if ($(e.target).hasClass(t)) return;
                        o.slick("slickPlay");
                    }
                }),
                a.$dots &&
                    a.$dots.on("keydown", function (e) {
                        37 === e.which && o.slick("slickPrev"), 39 === e.which && o.slick("slickNext"), (37 !== e.which && 39 !== e.which) || a.$dots.find(".slick-active button").focus();
                    });
        }
        function c(e, t, n, r) {
            var s = t.$slider,
                l = s.find("." + a),
                c = s.find('.velassSlide[data-slick-index="' + r + '"]');
            if (d(l)) {
                var u = l.find("." + o),
                    p = u.attr("id");
                velatheme.SlideshowVideo.pauseVideo(p), u.attr("tabindex", "-1");
            }
            if (d(c)) {
                var h = c.find("." + o),
                    v = h.attr("id");
                h.hasClass(i) ? velatheme.SlideshowVideo.playVideo(v) : h.attr("tabindex", "0");
            }
        }
        function d(e) {
            return e.find("." + o).length;
        }
        return (
            (s.prototype.togglePause = function () {
                var e = "#velaSlideshows" + this.$pause.data("id");
                this.$pause.hasClass(r) ? (this.$pause.removeClass(r), $(e).slick("slickPlay")) : (this.$pause.addClass(r), $(e).slick("slickPause"));
            }),
            s
        );
    })()),
    (velatheme.SlideshowVideo = (function () {
        var e = !1,
            a = !1,
            o = !1,
            i = !1,
            t = !1,
            n = {},
            r = [],
            s = {
                ratio: 16 / 9,
                playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, controls: 0, showinfo: 0, wmode: "opaque", branding: 0, autohide: 0, rel: 0 },
                events: {
                    onReady: function (e) {
                        e.target.setPlaybackQuality("hd1080");
                        var a = f(e);
                        switch ((u(), $("#" + a.id).attr("tabindex", "-1"), w(), a.type)) {
                            case "background-chrome":
                            case "background":
                                e.target.mute(), a.$parentSlide.hasClass(l.currentSlide) && c(a.id);
                        }
                        a.$parentSlide.addClass(l.loaded);
                    },
                    onStateChange: function (e) {
                        var a = f(e);
                        switch (e.data) {
                            case 0:
                                !(function (e) {
                                    switch (e.type) {
                                        case "background":
                                            r[e.id].seekTo(0);
                                            break;
                                        case "background-chrome":
                                            r[e.id].seekTo(0), v(e.id);
                                            break;
                                        case "chrome":
                                            v(e.id);
                                    }
                                })(a);
                                break;
                            case 1:
                                p(a);
                                break;
                            case 2:
                                h(a);
                        }
                    },
                },
            },
            l = {
                playing: "video-is-playing",
                paused: "video-is-paused",
                loading: "video-is-loading",
                loaded: "video-is-loaded",
                slideshowWrapper: "velaSlideshowWrapper",
                slide: "velassSlide",
                slideBackgroundVideo: "velassSlideBackgroundVideo",
                slideDots: "slick-dots",
                videoChrome: "velassVideo-chrome",
                videoBackground: "velassVideoBackground",
                playVideoBtn: "btnssVideoControlPlay",
                closeVideoBtn: "btnssVideoControlClose",
                currentSlide: "slick-current",
                slickClone: "slick-cloned",
                supportsAutoplay: "autoplay",
                supportsNoAutoplay: "no-autoplay",
            };
        function c(o, t) {
            var s = n[o],
                c = r[o],
                u = n[o].$parentSlide;
            if (i) p(s);
            else if (t || (e && a)) return u.removeClass(l.loading), p(s), void c.playVideo();
            e ||
                (function (o, i) {
                    o.playVideo(),
                        (function (e) {
                            var o,
                                i,
                                t = $.Deferred();
                            return (
                                (o = setInterval(function () {
                                    e.getCurrentTime() <= 0 || ((a = !0), clearInterval(o), clearTimeout(i), t.resolve());
                                }, 500)),
                                (i = setTimeout(function () {
                                    clearInterval(o), t.reject();
                                }, 4e3)),
                                t
                            );
                        })(o)
                            .then(function () {
                                d(!0);
                            })
                            .fail(function () {
                                d(!1), o.stopVideo();
                            })
                            .always(function () {
                                (e = !0), i.removeClass(l.loading);
                            });
                })(c, u);
        }
        function d(a) {
            var o = a ? l.supportsAutoplay : l.supportsNoAutoplay;
            $(document.documentElement).addClass(o), a || (i = !0), (e = !0);
        }
        function u() {
            o || ($(window).width() < 750 && (i = !0), i && d(!1), (o = !0));
        }
        function p(e) {
            var a = e.$parentSlideshowWrapper,
                o = e.$parentSlide;
            if ((o.removeClass(l.loading), "background" !== e.status)) {
                switch (($("#" + e.id).attr("tabindex", "0"), e.type)) {
                    case "chrome":
                    case "background-chrome":
                        a.removeClass(l.paused).addClass(l.playing), o.removeClass(l.paused).addClass(l.playing);
                }
                o.find("." + l.closeVideoBtn).focus();
            }
        }
        function h(e) {
            var a = e.$parentSlideshowWrapper,
                o = e.$parentSlide;
            "background-chrome" !== e.type
                ? ("closed" !== e.status && "background" !== e.type && (a.addClass(l.paused), o.addClass(l.paused)),
                  "chrome" === e.type && "closed" === e.status && (a.removeClass(l.paused), o.removeClass(l.paused)),
                  a.removeClass(l.playing),
                  o.removeClass(l.playing))
                : v(e.id);
        }
        function v(e) {
            var a = n[e],
                o = a.$parentSlideshowWrapper,
                i = a.$parentSlide,
                t = [l.pause, l.playing].join(" ");
            switch (($("#" + a.id).attr("tabindex", "-1"), (a.status = "closed"), a.type)) {
                case "background-chrome":
                    r[e].mute(),
                        (function (e) {
                            var a = $("#" + e)
                                .addClass(l.videoBackground)
                                .removeClass(l.videoChrome);
                            n[e].$parentSlide.addClass(l.slideBackgroundVideo), (n[e].status = "background"), g(a);
                        })(e);
                    break;
                case "chrome":
                    r[e].stopVideo(), h(a);
            }
            o.removeClass(t), i.removeClass(t);
        }
        function f(e) {
            return n[e.target.h.id];
        }
        function m(e) {
            var a = n[e];
            switch ((a.$parentSlide.addClass(l.loading), (a.status = "open"), a.type)) {
                case "background-chrome":
                    !(function (e) {
                        $("#" + e)
                            .removeAttr("style")
                            .removeClass(l.videoBackground)
                            .addClass(l.videoChrome),
                            n[e].$parentSlideshowWrapper.removeClass(l.slideBackgroundVideo).addClass(l.playing),
                            n[e].$parentSlide.removeClass(l.slideBackgroundVideo).addClass(l.playing),
                            (n[e].status = "open");
                    })(e),
                        r[e].unMute(),
                        c(e, !0);
                    break;
                case "chrome":
                    c(e, !0);
            }
            $(document).on("keydown.videoPlayer", function (a) {
                27 === a.keyCode && v(e);
            });
        }
        function w() {
            $("." + l.videoBackground).each(function (e, a) {
                g($(a));
            });
        }
        function g(e) {
            var a = e.closest("." + l.slide);
            if (!a.hasClass(l.slickClone)) {
                var o = a.width(),
                    i = e.width(),
                    t = e.height();
                o / s.ratio < t
                    ? ((i = Math.ceil(t * s.ratio)),
                      e
                          .width(i)
                          .height(t)
                          .css({ left: (o - i) / 2, top: 0 }))
                    : ((t = Math.ceil(o / s.ratio)),
                      e
                          .width(o)
                          .height(t)
                          .css({ left: 0, top: (t - t) / 2 })),
                    e.prepareTransition().addClass(l.loaded);
            }
        }
        function y() {
            $(document).on("click.videoPlayer", "." + l.playVideoBtn, function (e) {
                m($(e.currentTarget).data("controls"));
            }),
                $(document).on("click.videoPlayer", "." + l.closeVideoBtn, function (e) {
                    v($(e.currentTarget).data("controls"));
                }),
                $(window).on(
                    "resize.videoPlayer",
                    $.debounce(250, function () {
                        t && w();
                    })
                );
        }
        return {
            init: function (e) {
                if (
                    e.length &&
                    ((n[e.attr("id")] = {
                        id: e.attr("id"),
                        videoId: e.data("id"),
                        type: e.data("type"),
                        status: "chrome" === e.data("type") ? "closed" : "background",
                        videoSelector: e.attr("id"),
                        $parentSlide: e.closest("." + l.slide),
                        $parentSlideshowWrapper: e.closest("." + l.slideshowWrapper),
                        controls: "background" === e.data("type") ? 0 : 1,
                        slideshow: e.data("slideshow"),
                    }),
                    !t)
                ) {
                    var a = document.createElement("script");
                    a.src = "https://www.youtube.com/iframe_api";
                    var o = document.getElementsByTagName("script")[0];
                    o.parentNode.insertBefore(a, o);
                }
            },
            loadVideos: function () {
                for (var e in n)
                    if (n.hasOwnProperty(e)) {
                        var a = $.extend({}, s, n[e]);
                        (a.playerVars.controls = a.controls), (r[e] = new YT.Player(e, a));
                    }
                y(), (t = !0);
            },
            loadVideo: function (e) {
                if (t) {
                    var a = $.extend({}, s, n[e]);
                    (a.playerVars.controls = a.controls), (r[e] = new YT.Player(e, a)), y();
                }
            },
            playVideo: function (e) {
                (o || i) && e && "function" == typeof r[e].playVideo && c(e);
            },
            pauseVideo: function (e) {
                r[e] && "function" == typeof r[e].pauseVideo && r[e].pauseVideo();
            },
            removeEvents: function () {
                $(document).off(".videoPlayer"), $(window).off(".videoPlayer");
            },
        };
    })()),
    (velatheme.slideshows = {}),
    (velatheme.SlideshowSection = function (e) {
        var a = (this.$container = $(e)).attr("data-section-id"),
            o = (this.slideshow = "#velaSlideshows" + a);
        $(".velassVideo", o).each(function () {
            var e = $(this);
            velatheme.SlideshowVideo.init(e), velatheme.SlideshowVideo.loadVideo(e.attr("id"));
        }),
            (velatheme.slideshows[o] = new velatheme.Slideshow(o));
    }),
    (velatheme.SlideshowSection.prototype = _.assignIn({}, velatheme.SlideshowSection.prototype, {
        onUnload: function () {
            delete velatheme.slideshows[this.slideshow];
        },
        onBlockSelect: function (e) {
            var a = $(this.slideshow),
                o = $(".velassSlide" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
            a.slick("slickGoTo", o).slick("slickPause");
        },
        onBlockDeselect: function () {
            $(this.slideshow).slick("slickPlay");
        },
    })),
    $(document).ready(function () {


      $(window).load(function(){
          $('.syncHeights').syncHeight({ 'updateOnResize': true});
      });
      $(window).resize(function(){
          if($(window).width() < 992){
              $('.syncHeights').unSyncHeight();
          }
      });

      $('.category-column.with-excerpt a').on( 'click touch', function(e){
        e.preventDefault();
        $( this ).parents( '.category-column' ).toggleClass( 'active' );
        if( $( this ).parents( '.category-column' ).hasClass( 'active') ) {
          $( this ).parents( '.category-column' ).find( '.content-inner' ).slideDown(500);
        } else {
          $( this ).parents( '.category-column' ).find( '.content-inner' ).slideUp(500);
        }
      })

      $('#loading-animation').addClass( 'ready' );
      setTimeout(function() {
        $('#velaHeader').removeAttr('data-aos');
        $('#velaHeader').removeAttr('data-aos-delay');
        $('.template-index').addClass('ready');
      }, 3400);

      $('#sidebarAjaxFilter .titleSidebar').on( 'click touch', function(e){
        $('#sidebarAjaxFilter .velaContent' ).slideToggle(300);
        $( this ).find( 'span' ).toggleClass( 'active' );
        if( $( this ).find( 'span' ).hasClass( 'active') ) {
          $( this ).find( 'span' ).empty().text( "Close filters");
        } else {
          $( this ).find( 'span' ).empty().text( "Filters");
        }
      });

      $('.anchor-link').on('click touch', function (e) {
        e.preventDefault();
        var target = $(this).attr( 'href' );
        if ($(target).length > 0) {
          $("html, body").animate({ scrollTop: $(target).offset().top - 85 }, 400);
          return false;
        }
      });


      $(document).on('click touch', '.image-popup', function () {
        var src = $( this ).attr( 'href' );
        $.magnificPopup.open({
            items: {
                src: src
            },
            preloader: false,
            type: 'inline'
        }, 0);
      });
      $(document).on("click", ".popup-modal-dismiss", function (e) {
        e.preventDefault();
        $.magnificPopup.close();
      });


      setTimeout(function() {
        $('.productBox .formContactUs .globo-form-app .g-container>p').remove();      
      }, 500);
      
        $(vela.init),
            $("body").on("ajaxCart.afterCartLoad", function (e, a) {
                "drawer" == window.ajaxcart_type && vela.RightDrawer.open();
            }),
            new velatheme.Sections().register("velaSlideshowSection", velatheme.SlideshowSection);
    }),
    $(window).load(function () {
        $(vela.productImage);
    });


    /*
    $(".filter-tags a").on("click touch", function (e) {
      e.preventDefault();
      $(".filter-tags a").removeClass( 'active' );
      $( this ).addClass( 'active' );
      var url = $(this).attr("href");
      ajaxFilterGetContent(url);
    });
    */


const swiper = new Swiper(".productListHome:not(.image-popup-block) .swiper", {
  navigation: {
    nextEl: ".productListHome:not(.image-popup-block) .swiper-button-next",
    prevEl: ".productListHome:not(.image-popup-block) .swiper-button-prev",
  },
  scrollbar: {
    el: ".productListHome:not(.image-popup-block) .swiper-scrollbar",
  },
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    499: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1199: {
      slidesPerView: 4,
    },
  },
});

const largeSlider = () => {
  let largeSliders = document.querySelectorAll(".image-popup-block .swiper");
  let prevArrow = document.querySelectorAll(".image-popup-block .swiper-button-prev");
  let nextArrow = document.querySelectorAll(".image-popup-block .swiper-button-next");
  largeSliders.forEach((slider, index) => {
    let sliderLength = slider.children[0].children.length;
    console.log(sliderLength);
    if( sliderLength > 1 ) {
        var loop = true;
    } else {
        var loop = false;
    }
    const swiper = new Swiper(slider, {
      loop: loop,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: nextArrow[index],
        prevEl: prevArrow[index],
      },
      speed: 1000,
    });
  });
};
window.addEventListener("load", largeSlider);

var slidesPerView = 2;
if( $( '.productListHomeAlt .without-image' ).length > 0 ) {
  var slidesPerView = 4;
}

const swiperAlt = new Swiper('.productListHomeAlt .swiper', {
  navigation: {
    nextEl: '.productListHomeAlt .swiper-button-next',
    prevEl: '.productListHomeAlt .swiper-button-prev',
  },
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    499: {
      slidesPerView: 2
    },
    992: {
      slidesPerView: slidesPerView
    },
    1199: {
      slidesPerView: slidesPerView
    }
  }
});

const swiperAltAlt = new Swiper('.productListHomeAltAlt .swiper', {
  navigation: {
    nextEl: '.productListHomeAltAlt .swiper-button-next',
    prevEl: '.productListHomeAltAlt .swiper-button-prev',
  },
  scrollbar: {
    el: '.productListHomeAltAlt .swiper-scrollbar',
  },
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    499: {
      slidesPerView: 2
    },
    992: {
      slidesPerView: 3
    },
    1199: {
      slidesPerView: 4
    }
  }
});

const swiperAbout = new Swiper('.velaThreeBanner.about-slider-block .swiper', {
  navigation: {
    nextEl: '.velaThreeBanner.about-slider-block .swiper-button-next',
    prevEl: '.velaThreeBanner.about-slider-block .swiper-button-prev',
  },
  scrollbar: {
    el: '.velaThreeBanner.about-slider-block .swiper-scrollbar',
  },
  slidesPerView: 1,
  spaceBetween: 30,
  autoHeight: true
});

const swiperCta = new Swiper('.about-page-banner .swiper', {
  navigation: {
    nextEl: '.about-page-banner .swiper-button-next',
    prevEl: '.about-page-banner .swiper-button-prev',
  },
  scrollbar: {
    el: '.about-page-banner .swiper-scrollbar',
  },
  slidesPerView: 1,
  spaceBetween: 0,
  autoHeight: true
});


